import { AxiosResponse } from "axios";
import { API_PREFIX, API_VERSION, Command, HttpVerbType } from "../Command";
import { DownloadFitnessStatisticsReportReqData } from "./DownloadFitnessStatisticsReportReqData";

const ENDPOINT = "/fitness_statistics/download_report";

export class DownloadFitnessStatisticsReportCommand extends Command {
    endPoint: string = API_PREFIX + API_VERSION + ENDPOINT;
    httpVerb: HttpVerbType = "post";
    params: any = null;

    constructor(params: DownloadFitnessStatisticsReportReqData, exportType: string) {
        super();
        this.params = { exportType, ...params };

        this.responseType = exportType == "pdf" || exportType == "zip" ? "blob" : "text";
    }

    public async execute(): Promise<AxiosResponse> {
        return await this.executeCommand(this.params);
    }
}
